import React, { useState, useRef, useEffect } from "react";
import BG from "./assets/banner.gif";
import { HiChevronDoubleUp } from "react-icons/hi";

function App() {
  const [selectedButton, setSelectedButton] = useState(null);
  const contentRefs = {
    "deedat online": useRef(null),
    lookbook: useRef(null),
  };

  useEffect(() => {
    if (selectedButton) {
      const targetElement = contentRefs[selectedButton]?.current;
      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        window.scrollTo({
          top: 950,
          behavior: "smooth",
        });
      }
    }
  }, [selectedButton]);

  const handleButtonClick = (button) => {
    setSelectedButton(button);
  };

  const handleToTop = () => {
    setSelectedButton(null);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderContent = () => {
    return (
      <div>
        <div ref={contentRefs["deedat online"]}>
          {selectedButton === "deedat online" && (
            <iframe
              src="https://deedatclothing.com"
              className="w-full h-screen"
              title="Deedat Online"
            />
          )}
        </div>
        <div ref={contentRefs.lookbook}>
          {selectedButton === "lookbook" && (
            <iframe
              src="https://look.deedat.lk"
              className="w-full h-screen"
              title="Look Book"
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full" id="home">
      <img src={BG} alt="DEEDAT" className="bg-cover w-full h-screen" />
      <div className="flex w-full justify-center items-center gap-7 absolute bottom-8">
        <a
          className="w-[220px] px-4 py-2 text-2xl text-white border-2 border-white rounded-lg hover:bg-white hover:text-black duration-300 uppercase cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            handleButtonClick("deedat online");
          }}
        >
          Deedat Online
        </a>
        {selectedButton && (
          <a
            href="#home"
            className="px-4 py-2 text-2xl text-white hover:scale-150 duration-700 uppercase cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handleToTop();
            }}
          >
            <HiChevronDoubleUp className="animate-bounce duration-700" />
          </a>
        )}
        <a
          className="w-[220px] px-4 py-2 text-center text-2xl text-white border-2 border-white rounded-lg hover:bg-white hover:text-black duration-300 uppercase cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            handleButtonClick("lookbook");
          }}
        >
          Look Book
        </a>
      </div>
      {renderContent()}
    </div>
  );
}

export default App;
